export const getDeviceType = () => {
  const height = window.screen.height
  const width = window.screen.width
  if (height <= 950 && width <= 480) {
    return 'mobile'
  } else if (width <= 1199 && height <= 1180) {
    return 'mobile'
  } else {
    return 'desktop'
  }
}

/**
 * Detects if the current device is an iOS device
 * @returns {boolean} - Returns true if the device is iOS
 */
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}

/**
 * Detects if the device is running iOS Safari
 * @returns {boolean} - Returns true if the device is iOS Safari
 */
export const isIOSSafari = () => {
  const ua = navigator.userAgent
  const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
  const webkit = /WebKit/.test(ua)
  const iOSSafari = iOS && webkit && !/CriOS|FxiOS|OPiOS|mercury/.test(ua)
  return iOSSafari
}
